import { Component, type ErrorInfo, type ReactNode } from 'react';

import { reportError } from './telemetry';

interface Props {
  /** O que mostrar no lugar da árvore quebrada; a casca decide o texto. */
  fallback: ReactNode | ((error: unknown, reset: () => void) => ReactNode);
  /** Id do manifesto da tela, para o span de erro (U30). */
  routeId?: string;
  children: ReactNode;
}

interface State {
  error: unknown;
  failed: boolean;
}

/** Boundary que registra o erro na telemetria antes de mostrar o fallback. */
export class TelemetryErrorBoundary extends Component<Props, State> {
  override state: State = { error: undefined, failed: false };

  static getDerivedStateFromError(error: unknown): State {
    return { error, failed: true };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo) {
    reportError(error, {
      'error.source': 'react.boundary',
      'uyzy.route': this.props.routeId,
      'react.component_stack_depth': info.componentStack?.split('\n').length,
    });
  }

  reset = () => this.setState({ error: undefined, failed: false });

  override render() {
    if (!this.state.failed) return this.props.children;
    const { fallback } = this.props;
    return typeof fallback === 'function' ? fallback(this.state.error, this.reset) : fallback;
  }
}
